module.exports = __webpack_public_path__ + "img/laz(2).397244d2.jpg";